import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      
      <div className="pt-32 pb-20 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-8 md:p-12">
            <h1 className="heading-font text-4xl text-[#1E293B] mb-6" data-testid="privacy-policy-title">
              PRIVACY POLICY
            </h1>
            <p className="text-[#64748B] text-sm mb-8">
              Last Updated: January 2024
            </p>

            <div className="space-y-8 text-[#475569]">
              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">1. Introduction</h2>
                <p className="mb-4">
                  Simpson & Munro (India) Pvt Ltd ("we", "our", or "us") is committed to protecting your privacy. 
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you 
                  visit our website or use our services.
                </p>
                <p>
                  By accessing our website or using our services, you agree to the terms of this Privacy Policy.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">2. Information We Collect</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">2.1 Personal Information</h3>
                <p className="mb-3">We collect information that you provide directly to us, including:</p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Name and contact information (email, phone number)</li>
                  <li>Company name and GST number</li>
                  <li>Delivery address</li>
                  <li>Product specifications and requirements</li>
                  <li>Payment information (processed securely through third-party providers)</li>
                </ul>

                <h3 className="font-semibold text-[#1E293B] mb-2">2.2 Automatically Collected Information</h3>
                <p className="mb-3">When you visit our website, we may automatically collect:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Browser type and version</li>
                  <li>IP address and device information</li>
                  <li>Pages visited and time spent on pages</li>
                  <li>Referring website addresses</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">3. How We Use Your Information</h2>
                <p className="mb-3">We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Process and fulfill your orders and quotations</li>
                  <li>Communicate with you about products, services, and orders</li>
                  <li>Send quotations, invoices, and order confirmations</li>
                  <li>Improve our products, services, and website</li>
                  <li>Comply with legal obligations</li>
                  <li>Detect and prevent fraud or unauthorized activities</li>
                  <li>Send marketing communications (with your consent)</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">4. Information Sharing and Disclosure</h2>
                <p className="mb-3">We do not sell your personal information. We may share your information with:</p>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">4.1 Service Providers</h3>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Payment processors</li>
                  <li>Shipping and logistics companies</li>
                  <li>Email service providers</li>
                  <li>Website hosting and analytics providers</li>
                </ul>

                <h3 className="font-semibold text-[#1E293B] mb-2">4.2 Legal Requirements</h3>
                <p>We may disclose information if required by law or to protect our rights and safety.</p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">5. Data Security</h2>
                <p className="mb-3">
                  We implement appropriate technical and organizational measures to protect your personal information, including:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Secure SSL/TLS encryption for data transmission</li>
                  <li>Regular security assessments and updates</li>
                  <li>Access controls and authentication</li>
                  <li>Secure data storage and backup systems</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">6. Data Retention</h2>
                <p>
                  We retain your personal information for as long as necessary to fulfill the purposes outlined in this 
                  Privacy Policy, comply with legal obligations, resolve disputes, and enforce our agreements. 
                  Typically, we retain customer data for 7 years in accordance with Indian tax and business laws.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">7. Your Rights</h2>
                <p className="mb-3">You have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
                  <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
                  <li><strong>Deletion:</strong> Request deletion of your personal information (subject to legal requirements)</li>
                  <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
                  <li><strong>Restriction:</strong> Request restriction of processing in certain circumstances</li>
                </ul>
                <p className="mt-3">
                  To exercise these rights, please contact us at simpsmunro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">8. Cookies and Tracking Technologies</h2>
                <p className="mb-3">
                  We use cookies and similar tracking technologies to improve your browsing experience and analyze website traffic. 
                  You can control cookies through your browser settings.
                </p>
                <p className="mb-2"><strong>Types of cookies we use:</strong></p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Essential cookies:</strong> Necessary for website functionality</li>
                  <li><strong>Analytics cookies:</strong> Help us understand how visitors use our website</li>
                  <li><strong>Functional cookies:</strong> Remember your preferences</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">9. Third-Party Links</h2>
                <p>
                  Our website may contain links to third-party websites. We are not responsible for the privacy practices 
                  or content of these external sites. We encourage you to review their privacy policies.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">10. Children's Privacy</h2>
                <p>
                  Our services are intended for businesses and professionals. We do not knowingly collect information 
                  from children under 18 years of age.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">11. International Data Transfers</h2>
                <p>
                  Your information may be transferred to and processed in countries other than India. We ensure 
                  appropriate safeguards are in place to protect your information in accordance with this Privacy Policy.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">12. Changes to This Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. The updated version will be indicated by an 
                  updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">13. Contact Us</h2>
                <p className="mb-3">
                  If you have questions or concerns about this Privacy Policy or our data practices, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                  <p className="font-semibold text-[#1E293B] mb-3">Simpson & Munro (India) Pvt Ltd</p>
                  <p>4 Lyons Range</p>
                  <p>Kolkata 700001</p>
                  <p>West Bengal, India</p>
                  <p className="mt-3">
                    <strong>Email:</strong> simpsmunro@gmail.com<br/>
                    <strong>Phone:</strong> +91 33 2248 1686
                  </p>
                </div>
              </section>

              <section className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <p className="text-sm text-[#1E293B]">
                  <strong>Note:</strong> This Privacy Policy is governed by the laws of India. Any disputes arising 
                  from this policy will be subject to the exclusive jurisdiction of the courts in Kolkata, India.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
